import { I18n, i18n } from '@lingui/core';
import { I18nProvider, useLingui } from '@lingui/react';
import React, { PropsWithChildren, useEffect } from 'react';
import { BaseLocales, getDefaultCatalogs } from '../locales/i18nLingui';

if (!i18n.locale) {
  i18n.load(BaseLocales.English, {});
  i18n.activate(BaseLocales.English);
}

export const LinguiI18nContextProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  useEffect(() => {
    let cancelled = false;

    const initializeI18n = async () => {
      const catalogs = await getDefaultCatalogs();
      i18n.load(BaseLocales.English, catalogs[BaseLocales.English]);
      if (!cancelled && i18n.locale === BaseLocales.English) {
        i18n.activate(BaseLocales.English);
      }
    };

    initializeI18n();

    return () => {
      cancelled = true;
    };
  }, []);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};

export const useLinguiI18n = (): I18n => useLingui().i18n;
